<template>
	<div id="new-tour">
    <form-tour editingMode="create"/>
	</div>
</template>

<script>
import api from "../../api";
import formTour from './formTour'
export default {
  name: "newTour",
  components: {
    formTour
  }
}
</script>

<style lang='css'>
#new-tour {
	color: #53574D;
}
</style>
